/**
 * Component for displaying summary of rules validation status
 */

function RulesSummary({ validationStatus, rulesCount }) {
    if (rulesCount === 0) {
        return (
            <div className="rules-summary rules-summary-empty">
                <p>Zatím nemáte nastavena žádná pravidla. Klikněte na "+ Přidat pravidlo" pro vytvoření prvního pravidla.</p>
            </div>
        );
    }

    if (!validationStatus) {
        return null;
    }

    const { violations, warnings, results } = validationStatus;
    const totalRules = Object.keys(results).length;
    const satisfiedCount = totalRules - violations.length - warnings.length;

    const getStatusClass = () => {
        if (violations.length > 0) {
            return 'rules-summary-error';
        }
        if (warnings.length > 0) {
            return 'rules-summary-warning';
        }
        return 'rules-summary-success';
    };

    const getStatusMessage = () => {
        if (violations.length > 0) {
            return `${violations.length} ${violations.length === 1 ? 'porušené pravidlo' : 'porušená pravidla'}`;
        }
        if (warnings.length > 0) {
            return `${warnings.length} ${warnings.length === 1 ? 'nesplněné pravidlo' : 'nesplněná pravidla'}`;
        }
        return 'Všechna pravidla splněna';
    };

    return (
        <div className={`rules-summary ${getStatusClass()}`}>
            <div className="rules-summary-stats">
                <span className="rules-summary-count">
                    {satisfiedCount}/{totalRules} pravidel splněno
                </span>
                <span className="rules-summary-status">
                    {getStatusMessage()}
                </span>
            </div>

            {violations.length > 0 && (
                <div className="rules-summary-violations">
                    <strong>Blokující problémy:</strong>
                    <ul>
                        {violations.map((violation, index) => (
                            <li key={index}>{violation.message}</li>
                        ))}
                    </ul>
                </div>
            )}

            {warnings.length > 0 && violations.length === 0 && (
                <div className="rules-summary-warnings">
                    <strong>Upozornění:</strong>
                    <ul>
                        {warnings.map((warning, index) => (
                            <li key={index}>{warning.message}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default RulesSummary;
